import { Injectable } from '@angular/core';
import {
  LabelStyle,
  IEdge,
  IGraph,
  ILabel,
  INode,
  InteriorNodeLabelModel,
  TextWrapping,
} from '@yfiles/yfiles';
import { ProcessNodeTag } from '../models/business-process.model';
import { BusinessProcessNodeSizingService } from './business-process-node-sizing.service';
@Injectable({ providedIn: 'root' })
export class BusinessProcessLabelService {
  private readonly nodeStyle = new LabelStyle({
    font: '13px Inter, "Segoe UI", Arial, sans-serif',
    textFill: '#1F2937',
    horizontalTextAlignment: 'center',
    verticalTextAlignment: 'center',
    wrapping: TextWrapping.WRAP_WORD_ELLIPSIS,
  });
  private readonly outcomeStyle = new LabelStyle({
    font: '12px Inter, "Segoe UI", Arial, sans-serif',
    textFill: '#1F2937',
    horizontalTextAlignment: 'center',
    verticalTextAlignment: 'center',
    wrapping: TextWrapping.WRAP_WORD_ELLIPSIS,
  });
  private readonly edgeStyle = new LabelStyle({
    font: '11px Inter, "Segoe UI", Arial, sans-serif',
    textFill: '#475569',
    wrapping: TextWrapping.WRAP_WORD_ELLIPSIS,
  });
  constructor(private readonly sizing: BusinessProcessNodeSizingService) {}
  addNodeLabel(graph: IGraph, node: INode): ILabel {
    const d = (node.tag as ProcessNodeTag).process;
    const a = this.sizing.getTextArea(d.type, {
      width: node.layout.width,
      height: node.layout.height,
    });
    return graph.addLabel({
      owner: node,
      text: d.label,
      layoutParameter: InteriorNodeLabelModel.CENTER,
      style: d.type === 'outcome' ? this.outcomeStyle : this.nodeStyle,
      preferredSize: { width: a.width, height: a.height },
    });
  }
  addEdgeLabel(graph: IGraph, owner: IEdge, text: string): ILabel {
    return graph.addLabel({
      owner,
      text,
      style: this.edgeStyle,
      preferredSize: { width: 180, height: 36 },
    });
  }
}
